/* jshint esversion: 6 */
import React from 'react';
import Modal from 'app/components/common/Modal.jsx';
import CCVersionModule from 'app/mixins/CCVersionModule.jsx';
import { FormattedDate } from 'react-intl';
import moment from 'moment';
import { compose } from 'redux';
import * as _ from 'underscore';

class CCVersion15 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            version: 15,
            showCouponCode: false
        };

        this.toggleCoupon = this.toggleCoupon.bind(this);

    }

    componentDidMount() {

        this.props.onMount(this.state.version);

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.couponCode === '' && this.props.couponCode !== '' && !this.state.showCouponCode) {
            this.setState({
                showCouponCode: true
            });
        }

    }

    toggleCoupon() {
        // don't allow the coupon code to be toggled if anything is in there
        if (this.props.couponCode !== '') {
            return;
        }

        this.setState({
            showCouponCode: this.state.showCouponCode ? false : true
        });

    }

    render() {

        let content = null,
            buttonLabel = this.props.buttonLabel,
            constants = this.props.app.config.constants,
            annualClass = 'cc-plan-info-cell annual term-chooser',
            monthlyClass = 'cc-plan-info-cell monthly term-chooser',
            planInfoBlock = null,
            totalBlock = null,
            trialLegalBlock = null,
            paymentTotalCopy = '',
            trialInfoBlock = null,
            trialEnd = 0,
            headerContent = null,
            planInfoClass = '',
            annualPrice = 0,
            monthlyPrice = 0,
            addOnLabel = '',
            savingsPct = 25,
            validatingCoupon = null,
            couponErrors = null,
            validatedCoupon = null,
            savingsElement = null,
            couponBlock = null;

        const getPercentDiscountPrice = (price, discount) => {
            let newPrice = price * discount,
                priceParts = newPrice.toString().split(".");

            return `${priceParts[0]}.${priceParts[1].substring(0, 2)}`;
        };

        // different savings for different plans
        if (this.props.plan === constants.PUB_LEVEL_6) {
            savingsPct = 28;
        } else if (this.props.plan === constants.PUB_LEVEL_15) {
            savingsPct = 18;
        } else if (this.props.plan === constants.PUB_LEVEL_16) {
            savingsPct = 17;
        }

        // create an element since all the percentages kinda go out the window
        // when a coupon is in play
        savingsElement = (
            <span className="cc-plan-savings"> (save {savingsPct}%) </span>
        );

        if (this.props.isValidCoupon) {
            validatedCoupon = this.props.plans.validatedCoupon;
        }

        headerContent = (
            <span>
                dlvr.it {this.props.planLabel}
            </span>
        );
        
        if (buttonLabel !== 'Processing') {
            //buttonLabel = `Unlock ${this.props.planLabel} Now`;
            buttonLabel = 'Get Started';
        }

        if (this.props.prices === null) {
            return null;
        }

        if (this.props.addOnPrices && this.props.addOns !== null) {
            annualPrice = (this.props.prices[constants.SUBSCRIPTION_TERM_ANNUAL] + (this.props.addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS][constants.SUBSCRIPTION_TERM_ANNUAL] * this.props.addOns.add_on_social)).toFixed(2);
            monthlyPrice = (this.props.prices[constants.SUBSCRIPTION_TERM_MONTHLY] + (this.props.addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS][constants.SUBSCRIPTION_TERM_MONTHLY] * this.props.addOns.add_on_social)).toFixed(2);
        } else {
            annualPrice = this.props.prices[constants.SUBSCRIPTION_TERM_ANNUAL].toFixed(2);
            monthlyPrice = this.props.prices[constants.SUBSCRIPTION_TERM_MONTHLY].toFixed(2);
        }

        if (this.props.planTerm == constants.SUBSCRIPTION_TERM_ANNUAL) {
            annualClass += ' selected';
        } else {
            monthlyClass += ' selected';
        }

        if (this.props.isValidCoupon) {

            let validatedCoupon = this.props.plans.validatedCoupon;

            if (!_.isEmpty(validatedCoupon)) {
                if (validatedCoupon.discount.type === 'percent') {
                    let discount = ((100 - validatedCoupon.discount.percent) / 100);
                    if (this.props.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
                        monthlyPrice = getPercentDiscountPrice(monthlyPrice, discount);
                        paymentTotalCopy = `Total: $${monthlyPrice}`;
                    } else if (this.props.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
                        annualPrice = getPercentDiscountPrice(annualPrice, discount);
                        paymentTotalCopy = `Total: $${annualPrice}`;
                        savingsElement = null;
                    }
                    let unitLabel = validatedCoupon.discount.temporalUnit;
                    if (validatedCoupon.discount.temporalAmount > 1) {
                        unitLabel += "s";
                    }
                    trialInfoBlock = (
                        <div className="plan-trial-price-detail v14">
                            {`Enjoy ${validatedCoupon.discount.percent}% off for ${validatedCoupon.discount.temporalAmount} ${unitLabel}`}
                        </div>
                    );
                } else if (validatedCoupon.discount.type === 'fixed') {
                    let fixedDiscount = validatedCoupon.discount.currencies[0].amount;

                    if (this.props.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
                        monthlyPrice = monthlyPrice - fixedDiscount;
                        monthlyPrice = monthlyPrice.toFixed(2);
                        paymentTotalCopy = `Total: $${monthlyPrice}`;
                    } else if (this.props.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
                        annualPrice = annualPrice - fixedDiscount;
                        annualPrice = annualPrice.toFixed(2);
                        paymentTotalCopy = `Total: $${annualPrice}`;
                        savingsElement = null;
                    }
                    // some special cases for specific codes
                    if (validatedCoupon.code === '99top') {
                        trialInfoBlock = (
                            <div className="plan-trial-price-detail v14">
                                Get 5 months free - Our best price
                            </div>
                        );
                    } else {
                        trialInfoBlock = (
                            <div className="plan-trial-price-detail v14">
                                {`Enjoy $${fixedDiscount.toFixed(2)} off of your new plan!`}
                            </div>
                        );
                    }
                    
                } else {
                    paymentTotalCopy = 'Total: $0.00';
                    trialEnd = moment().add(validatedCoupon.freeTrialAmount, validatedCoupon.freeTrialUnit).format();
                    trialInfoBlock = (
                        <div className="plan-trial-price-detail v14">
                            Enjoy your completely FREE trial until <FormattedDate value={trialEnd} year='numeric' day='numeric' month='long' />
                        </div>
                    );
                }
            } 

        } else {
            if (this.props.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
                paymentTotalCopy = `Total: $${monthlyPrice}`;
            } else if (this.props.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
                paymentTotalCopy = `Total: $${annualPrice}`;
            }
        }

        // special case where Charles would like to entice the user back to annual if possible
        if (!this.props.isValidCoupon && Object.keys(this.props.plans.validatedCoupon).length) {
            if (this.props.plans.validatedCoupon.code === '99top') {
                trialInfoBlock = (
                    <div className="plan-trial-price-detail v14">
                        Choose annual - Get 5 months free
                    </div>
                );
            }
        }

        if (this.props.action === 'subscribe') {
            planInfoClass = 'cc-plan-info v15 ineligible';
            if (this.props.addOns && this.props.addOns.add_on_social !== 0) {
                addOnLabel = "+ " + this.props.addOns.add_on_social;
                if (this.props.addOns.add_on_social == 1) {
                    addOnLabel += " add-on";
                } else {
                    addOnLabel += " add-ons";
                }
            }

            planInfoBlock = (
                <div className={planInfoClass}>
                    <div className={annualClass} data-context="modal" data-term={constants.SUBSCRIPTION_TERM_ANNUAL} onClick={this.props.changeTerm}>
                        <input type="radio" value={constants.SUBSCRIPTION_TERM_ANNUAL} data-term={constants.SUBSCRIPTION_TERM_ANNUAL} data-context="modal" onChange={this.props.changeTerm} checked={this.props.planTerm == constants.SUBSCRIPTION_TERM_ANNUAL}/> ${annualPrice} / year {savingsElement}
                    </div>
                    <div className={monthlyClass} data-context="modal" data-term={constants.SUBSCRIPTION_TERM_MONTHLY} onClick={this.props.changeTerm}>
                        <input type="radio" value={constants.SUBSCRIPTION_TERM_MONTHLY} data-term={constants.SUBSCRIPTION_TERM_MONTHLY} data-context="modal" onChange={this.props.changeTerm} checked={this.props.planTerm == constants.SUBSCRIPTION_TERM_MONTHLY}/> ${monthlyPrice} / month
                    </div>
                </div>
            );
            totalBlock = (
                <div className="payment-total">
                    {paymentTotalCopy}
                </div>
            );
            trialLegalBlock = (
                <div className="disclaimer-block">
                    Risk free. Cancel anytime.
                </div>
            )
        } else {
            planInfoBlock = (
                <div className="cc-plan-label center">Update your billing details</div>
            );
            buttonLabel = "Update";
        }

        if (this.props.isValidatingCoupon) {
            validatingCoupon = (
                <div className="validation-spinner">
                    <i className="fa fa-spinner fa-spin"></i>
                </div>
            );
        } else if (this.props.isValidCoupon !== null) {
            let feedbackIcon = (this.props.isValidCoupon) ? 'fa fa-check' : 'fa fa-times',
                feedbackWrapper = (this.props.isValidCoupon) ? 'feedback-icon valid' : 'feedback-icon invalid';

            validatingCoupon = (
                <div className={feedbackWrapper} onClick={this.props.resetCoupon}>
                    <i className={feedbackIcon}></i>
                </div>
            );

        }

        // unComment out coupon block 12/18/23
        if (this.props.action === 'subscribe') {
            if (this.props.couponError) {
                couponErrors = (
                    <div className="coupon-error">
                        {this.props.couponError}
                    </div>
                );
            }

            couponBlock = (
                <div className="coupon-block">
                    <div className="coupon-block-wrapper">
                        <div className="coupon-copy" onClick={this.toggleCoupon}>Have a promo code?</div>
                        {this.state.showCouponCode ? (
                            <div className="coupon-field-wrapper">
                                {validatingCoupon}
                                <input type="text"
                                    className="text-input medium"
                                    onChange={this.props.validateCoupon}
                                    placeholder="Enter Promo Code"
                                    value={this.props.couponCode}/>
                            </div>
                        ) : null}
                    </div>
                    {couponErrors}
                </div>
            );
        }
        

        content = (
            <div id="credit-card-modal" className="credit-card-modal v15">
                <div id="threeDS-challenge"></div>
                {planInfoBlock}
                {trialInfoBlock}
                <form id="recurly-form" action="#" method="POST">
        			<div className="recurly-error">{this.props.recurlyMsg}</div>
                    <div className={`payment-form-wrapper ${this.props.action}`}>
                        <div className="payment-form clearfix">
                            <div className="input-group payment-type-selector clearfix">
                                <div className="payment-type cc-selector">
                                    <div className="payment-radio">
                                        <input type="radio" value={'card'} checked={this.props.paymentType === 'card'} onChange={this.props.changePaymentType} />
                                    </div>
                                    <div className="card visa" onClick={this.props.changePaymentType} value='card'></div>
                                    <div className="card mastercard" onClick={this.props.changePaymentType} value='card'></div>
                                    <div className="card american_express" onClick={this.props.changePaymentType} value='card'></div>
                                </div>
                                <div className="payment-type paypal-selector">
                                    <div className="payment-radio">
                                        <input type="radio" value={'paypal'} checked={this.props.paymentType === 'paypal'} onChange={this.props.changePaymentType} />
                                    </div>
                                    <div className="paypal-logo" onClick={this.props.changePaymentType} value='paypal'></div>
                                </div>
                                {totalBlock}
                            </div>
                            {this.props.paymentBlock}
                        </div>

                        {couponBlock}
                    </div>
        			<div className="button-group clearfix">
                        <button className={this.props.buttonClass} onClick={this.props.onCheckout} data-version={this.state.version}>
                            {buttonLabel}
                        </button>
        			</div>
                    {trialLegalBlock}
        		</form>
            </div>
        );

        let boxClass = 'v15';

        if (this.props.boxClass) {
            boxClass += ' ' + this.props.boxClass;
        }

        return (
            <Modal
                {...this.props}
                headerContent={headerContent}
                contentClass="cc-modal"
                content={content}
                boxClass={boxClass}
                close={this.props.closeAction}
                showClose={this.props.showClose}/>
        );

    }

};

CCVersion15.displayName = "CCVersion15";

const enhance = compose(
    CCVersionModule
);

export default enhance(CCVersion15);
